import http from '@/shared/api/http';
import type {
   DashboardBannersResponse,
   DashboardInfoResponse,
   DashboardNavResponse,
} from '@/shared/features/dashboardInfo/dashboardInfo.requests';

export const DashboardInfoApi = {
   get(): Promise<DashboardInfoResponse> {
      return http.get('/dashboard/info');
   },

   getNavigation(): Promise<DashboardNavResponse> {
      return http.get('/dashboard/info/navigation');
   },

   getBanners(): Promise<DashboardBannersResponse> {
      return http.get('/dashboard/info/banners');
   },
};
